// §N — the persistent preview bar (D-g). Fixed top, outside the portal's own
// header. Posts 'close' / 'send' to the host: the mobile WebView
// (window.ReactNativeWebView) or the Expo-web iframe stub (window.parent).
import { Eye, X } from 'lucide-react';

export type PreviewPortalStatus = 'staged' | 'live' | 'expired' | 'revoked';

interface Props {
  firstName: string;
  slug: string;
  status: PreviewPortalStatus;
}

export const PREVIEW_BAR_HEIGHT = 56;

function postToHost(msg: 'close' | 'send') {
  const w = window as Window & { ReactNativeWebView?: { postMessage: (m: string) => void } };
  if (w.ReactNativeWebView) { w.ReactNativeWebView.postMessage(msg); return; }
  if (window.parent !== window) window.parent.postMessage(msg, '*');
}

export function PreviewBar({ firstName, slug, status }: Props) {
  const staged = status === 'staged';
  return (
    <div style={barStyle} role="status">
      <Eye size={16} color="#fff" style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, lineHeight: '18px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {staged ? `Preview · ${firstName} hasn't received this yet` : `Preview · this is what ${firstName} sees`}
        </div>
        <div style={monoStyle}>app.crewbit.ca/crew/{slug} · read-only</div>
      </div>
      {staged && (
        <button type="button" onClick={() => postToHost('send')} style={pillStyle}>Send</button>
      )}
      <button type="button" onClick={() => postToHost('close')} aria-label="Close preview" style={iconBtnStyle}>
        <X size={18} color="#fff" />
      </button>
    </div>
  );
}

const barStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
  height: PREVIEW_BAR_HEIGHT, boxSizing: 'border-box',
  background: '#0B0F19', color: '#fff',
  display: 'flex', alignItems: 'center', gap: 10, padding: '0 12px 0 14px',
  fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
};

const monoStyle: React.CSSProperties = {
  fontSize: 11, lineHeight: '14px', opacity: 0.72,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
};

const pillStyle: React.CSSProperties = {
  flexShrink: 0, border: 'none', cursor: 'pointer',
  background: '#fff', color: '#0B0F19', fontWeight: 700, fontSize: 13,
  padding: '6px 14px', borderRadius: 999, fontFamily: 'inherit',
};

const iconBtnStyle: React.CSSProperties = {
  flexShrink: 0, border: 'none', cursor: 'pointer', background: 'transparent',
  width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center',
  borderRadius: 8, padding: 0,
};
